bookingApp.directive('skHeader', function($window, $location){
    return {
        link: function(scope, element, attrs, controller){
            // get the current location
            var window = angular.element($window);
            var initialPos = window.scrollTop();
            var hideClass = 'header-hidden';
            window.on('scroll',function(e){
                var newPos = window.scrollTop();
                if(newPos > 50){
                    // show or hide header
                    if(newPos > initialPos){
                        // hide header
                        element.addClass(hideClass);
                    } else {
                        //show header
                        element.removeClass(hideClass);
                    }
                    // reset scrolling stable
                    initialPos = newPos;
                }else{
                    element.removeClass(hideClass);
                }
            });
            scope.$location = $location;
            // filter event handler
            element.find('.filter-button').click(function(){
                scope.baseApp.controls.type = "full";
                scope.$location.path('/');
                scope.$apply();
            });
        }
    }
});